export default __webpack_public_path__ + "c32c59808c7618ded7526fb68ea380d0.svg";